import $ from "jquery"
import { trace } from "./helpers.js"


const FormValidator = {

  // auto validate forms
  FORM_SELECTOR: 'form.validate-me, form.formbuilder-form',
  // minimal password length
  MIN_PASSWORD_LENGTH: 1,

  // is email?
  isEmail( txt ) {
    let regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test( txt );
  },
  // is safe string ?
  isSafe( txt) {
    // let regex = /[\-\[\]\/\{\}\(\)\*\<\>\+\?\.\\\^\$\|]/g;
    // return !regex.test( txt );
    return true;
  },

  setFormFieldInvalid( $field ) {
    $field.addClass('has-error');
  },
  setFormFieldValid( $field ) {
    $field.removeClass('has-error');
  },

  validateFormField( $it ) {
    let fieldValid = true;
    let $input = $it.find('input, textarea');
    let type = $input.attr('type');
    let value = $input.val();
    switch (type) {
      case "email":
        if (!this.isEmail(value)) {
          fieldValid = false;
          this.setFormFieldInvalid($it);
        } else {
          this.setFormFieldValid($it);
        }
        break;
      case "checkbox":
        let ch = $input.prop("checked");
        if (!ch) {
          fieldValid = false; 
          this.setFormFieldInvalid($it);
        }else {
          this.setFormFieldValid($it);
        }
        break;
      case "password":
        if (value.length < this.MIN_PASSWORD_LENGTH) {
          fieldValid = false; 
          this.setFormFieldInvalid($it);
        } else {
          this.setFormFieldValid($it);
        }
        break;
      default:
        let unsafe = !this.isSafe(value);
        if ((value.length == 0) || (unsafe)){
          fieldValid = false; 
          this.setFormFieldInvalid($it);
        } else {
          this.setFormFieldValid($it);
        }
        break;
    }
    return fieldValid;
  },

  validateForm( $form ) {
    // trace("validate form", $form);
    let formValid = true;
    // each <div> with "required" class name
    $form.find('.required').each( (index, el)=> {
      let $it = $(el);
      if (!this.validateFormField( $it )) {
        formValid = false;
      }
    });
    return formValid;
  },

  // return a array with all form data (each input is an object)
  getFormData( $form ) {
    let dataArr = [];
    $form.find('.form-group').each( (index, el)=> {
      let $it = $(el);
      let $input = $it.find('input, textarea');
      let type = $input.attr('type');
      let name = $input.attr('name');
      let value = false;
      switch (type) {
        case "checkbox":
          // multiple checkboxes
          if ($input.length > 1) {
            value = '';
            let first = true;
            $input.each( (i, chb)=> {
              if ($(chb).prop("checked")) {
                if (first) {
                  first = false;
                  value += $(chb).attr("value");
                } else {
                  value += "," + $(chb).attr("value");
                }
              }
            });
          } else {
            value = $input.prop("checked");
          }
          break;
        default:
          value = $input.val();
          break;
      }
      let object = {
                    type,
                    name,
                    value
                  }
      dataArr.push( object );
    });
    return dataArr;
  },

  // ############
  // ### init ###
  // ############
  init() {
    // trace ("init form validator");
    $(this.FORM_SELECTOR).each((index,el)=> {
      let $form = $(el);
      let $submit = $form.find('[type="submit"]');
      $submit.on("click", (e)=> {
        return this.validateForm( $form );
      });
    });
  }
}

export default FormValidator;
